import React from 'react';
import {checkIfUserIsOnBroadcasterSection} from "../../util/utility";
import ContentLoader from "react-content-loader";
import * as _ from "lodash";
import {getUserProfile} from "../../util/business_logic";
import onlineCircle from "../../assets/images/icon-circle-blue@2x.png";
import PropTypes from "prop-types";

Followers.propTypes = {
    followersLeftNavParent: PropTypes.string.isRequired,
    toggleLeftNavParent: PropTypes.func.isRequired,
    followersList: PropTypes.array.isRequired,
    broadcaster_followers: PropTypes.object.isRequired,
    clickedOnIndividualUserForMessage: PropTypes.func.isRequired,
    clickedOnMessageAllToFollowers: PropTypes.func.isRequired,
};

function Followers(props) {

    const isBroadcaster = checkIfUserIsOnBroadcasterSection();

    if (isBroadcaster) {
        return (
            <ul className="left-nav">
                <li className={props.followersLeftNavParent} id="leftNavFollowers">
                    <a href="javascript:void(0);"
                       onClick={() => {
                           props.toggleLeftNavParent(3)
                       }}>
                        <div className="left following">Followers</div>
                        {
                            props.followersList.length > 0 &&
                            <div className="right">
                                {
                                    props.broadcaster_followers &&
                                    props.broadcaster_followers.followersList &&
                                    props.broadcaster_followers.followersList.data.total
                                }
                            </div>
                        }
                    </a>
                </li>

                {
                    props.followersList.length > 0 &&
                    <li className="active">
                        <a href="javascript:void(0);"
                           className="font-weight-normal"
                           onClick={props.clickedOnMessageAllToFollowers}>Announcement</a>
                    </li>
                }


                {
                    (props.broadcaster_followers.isFetching && props.followersList.length === 0)
                        ?
                        <ContentLoader
                            height={240}
                            speed={1}
                            primaryColor="#f3f3f3"
                            secondaryColor="#ecebeb"
                        >
                            <rect x="72" y="20" rx="4" ry="4" width="200" height="20"/>
                            <rect x="72" y="80" rx="4" ry="4" width="200" height="20"/>
                            <rect x="72" y="140" rx="4" ry="4" width="200" height="20"/>
                            <rect x="72" y="200" rx="4" ry="4" width="200" height="20"/>
                            <circle cx="36" cy="30" r="22"/>
                            <circle cx="36" cy="90" r="22"/>
                            <circle cx="36" cy="150" r="22"/>
                            <circle cx="36" cy="210" r="22"/>
                        </ContentLoader>
                        :
                        props.followersList.length > 0 && _.map(props.followersList, (data) => {
                            return (
                                <li key={data.user_id}
                                    onClick={props.clickedOnIndividualUserForMessage(data)}>
                                    <a href="javascript:void(0);">
                                        <div className="left"><span className="followers">
                                                        <img width={"100%"} src={getUserProfile(data.profile_pic)}
                                                             alt="Follower"/></span> {data.username}
                                        </div>
                                        {data.status === "online" && <div className="right">
                                            <img src={onlineCircle} alt="visible"/>
                                        </div>}
                                    </a>
                                </li>
                            )
                        })
                }

            </ul>
        );
    } else {
        return (<span/>)
    }

}

export default Followers;